<template>
  <div class="col-12 col-lg-9 mt-4 mt-lg-0">
    <div class="card">
      <div class="card-header">
        <h5>Returns</h5>
        <router-link to="/return-items" class="btn btn-xs btn-primary btnNew">NEW</router-link>
      </div>
      <div class="card-divider"></div>
      <div class="card-table">
        <div class="table-responsive-md">
          <table>
            <thead>
              <tr>
                <!-- <th>Select</th> -->
                <th>Return #</th>
                <th>Date</th>
                <th>Reason</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
                <list-item
                    v-for="rma in displayPage"
                    :key="rma.RODOONUM"
                    :returnItem="rma"
                    @remove_item="remove_item"
                >
                </list-item>
            </tbody>
          </table>
        </div>
      </div>
      <div class="card-divider"></div>
      <div class="card-footer">
          <base-pagination
              :perPage="perPage"
              :pages="pages"
              :currentPage="page"
              @updatePage="updatePage">
          </base-pagination>
      </div>
    </div>

    <base-dialog title="Confirm Delete" @close="cancelRemove" :open="selectedReturnOrder != null">
        <template #default>
        <p>Are you sure you want to delete Order #<b>{{selectedReturnOrder}}</b>?</p>
        </template>
        <template #actions>
        <button type="button" class="btn btn-sm btn-secondary" @click="cancelRemove">
            Cancel
        </button>
        <button type="button" class="btn btn-sm btn-primary" @click="confirmRemove">
            Ok
        </button>

        </template>
    </base-dialog>

  </div>
</template>

<style>
.btnNew{
    position: absolute;
    top: 10px;
    right: 10px;
}
</style>

<script>
import axiosvl from "../../../axios/axios-vl.js";
import BasePagination from "../../base/BasePagination.vue";
import ListItem from "./ListItem.vue";

export default {
    name: 'ReturnPanel',
    components: {  
        BasePagination,
        ListItem
    },

    data() {
        return {
            rmalist: [],
            page: 1,
            perPage: 10,
            pages: [],

            selectedReturnOrder: null
        }
    },

    watch: {
        rmalist () {
            // console.log('watch rmalist');
            this.setPages();
        }
    },


    computed: {
        displayPage () {
            return this.paginate(this.rmalist);
        },
    },

    methods: {
        setPages () {
            this.pages = [];
            let numberOfPages = Math.ceil(this.rmalist.length / this.perPage);
            for (let index = 1; index <= numberOfPages; index++) {
                this.pages.push(index);
            }
            console.log(this.pages);
        },

        paginate (rmalist) {
            let page = this.page;
            let perPage = this.perPage;
            let from = (page * perPage) - perPage;
            let to = (page * perPage);

            return  rmalist.slice(from, to);
        },

        fetchList() {
            const return_savedlist_uri = this.$store.getters['api/return_savedlist_uri'];
            axiosvl.post(return_savedlist_uri, {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                            "EHCUST": {"value": this.$store.getters.customer},
                        },
                    }
                }
            )
            .then((response) => {
                const RMALIST = response.data.webroutine.lists.RMALIST.entries;
                const res = [];
                for (const key in RMALIST) {
                    const obj = RMALIST[key];
                    res.push(obj);
                }
                this.rmalist = res;
                // console.log(this.rmalist);
                
            })
            .catch((error) => {
                this.isloading = false;
                this.servermessages.push('Something went wrong. Please try again later.');
                console.log("error - " + error);
            });
        },

        updatePage(currentPage) {
            this.page = currentPage;
        },

        remove_item(savedDRMA) {
            this.selectedReturnOrder = savedDRMA;
        },

        confirmRemove() {
            this.delete(this.selectedReturnOrder);
        },

        cancelRemove() {
            this.selectedReturnOrder = null;
        },

        /** delete web service */
        delete(savedDRMA) {
            this.isloading = true;
            const return_delete_uri = this.$store.getters['api/return_delete_uri'];
            axiosvl.post(return_delete_uri, {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                            "EHCUST": {"value": this.$store.getters.customer},
                            "SAVEDRMA": {"value": savedDRMA},
                        },
                    }
                }
            )
            .then((response) => {
                const fields = response.data.webroutine.fields;
                const RESULTCOD = fields.RESULTCOD.value;
                
                this.selectedReturnOrder = null;
                this.fetchList();

                if(RESULTCOD != 'OK'){
                    this.servermessages.push('Something went wrong. Please try again later.');
                }
            })
            .catch((error) => {
                this.isloading = false;
                this.servermessages.push('Something went wrong. Please try again later.');
                console.log("error - " + error);
            });
        },
    },

    created() {
        this.fetchList();
    }
}
</script>